<template>
    <v-container fluid>
    <!-- Filters -->
    <v-row>
        <v-col cols="12" md="6" sm="6">
            <v-select
            v-model="selectedCompany"
            :items="companyOptions"
            item-value="name"
            item-text="desc"
            label="Select Company"
            @change="fetchFilterOptions"
            outlined
            return-object
            ></v-select>
        </v-col>
       
        <v-col cols="12"  md ="6" sm="6" class="d-flex justify-space-around">
            <v-btn fab 
                outlined
                small 
                color="primary"
                icon @click="showFilters = !showFilters">
                <v-icon>{{ showFilters ? 'mdi-filter-menu' : 'mdi-filter-menu-outline' }}</v-icon>
            </v-btn>

            <v-btn
                class="mx-2"
                fab
                dark
                small
                color="teal"
                @click="fetchQuestions" :disabled="!selectedCompany"
                >
                <v-icon dark>
                    mdi-table-sync
                </v-icon>
            </v-btn>
            <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                @click="showAddDialog = true"
                >
                <v-icon dark>
                    mdi-plus
                </v-icon>
            </v-btn>
            <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                @click="fetchFilterOptions(true)"
                >
                <v-icon dark>
                    mdi-filter-remove-outline
                </v-icon>
            </v-btn>

            
        </v-col>
        <!-- Expandable Filter Section -->
        <v-expand-transition>
            <v-col cols="12" v-if="showFilters">
                <v-row>                    
                    <v-col cols="12" md="3" sm="3" v-if="selectedCompany !== 'All'">
                        <v-autocomplete
                        v-model="selectedDepartment"
                        :items="departments"
                        :loading="isloadingDepartments"
                        label="Select Department"
                        item-text="PDEPTMST_DESC"
                        item-value="PDEPTMST_DOCNO"
                        return-object
                        clearable
                        >
                        <template v-slot:item="{ item }">
                            <v-list-item-content>
                            <v-list-item-title v-text="item.PDEPTMST_DESC"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.PDEPTMST_DOCNO"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>     
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        No Department Available - 
                                        <span @click="fetchDepartments(true)" style="color: blue; cursor:pointer;">Search on Server</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>                    
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3" sm="3" v-if="selectedCompany !== 'All'">
                        <v-autocomplete
                        v-model="selectedDesignation"
                        :items="designations"
                        :loading="isloadingDesignations"
                        label="Select Designation"
                        item-text="DESIG_DESC"
                        item-value="DESIG_DOCNO"
                        return-object
                        clearable
                        >
                        <template v-slot:item="{ item }">
                            <v-list-item-content>
                            <v-list-item-title v-text="item.DESIG_DESC"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.DESIG_DOCNO"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template> 
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        No Designation Available - 
                                        <span @click="fetchDepartments(true)" style="color: blue; cursor:pointer;">Search on Server</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>                    
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                        <v-autocomplete
                        v-model="selectedType"
                        :items="apq_types"
                        label="Evaluation Type" 
                        clearable
                        >     
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                        <v-autocomplete
                        v-model="selectedCategory"
                        :items="categories"
                        label="Category Type" 
                        item-text="category_name"
                        item-value="category_code" 
                        return-object
                        clearable
                        >    
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        No Designation Available - 
                                        <span @click="fetchQuesCats" style="color: blue; cursor:pointer;">Search on Server</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>            
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
        </v-expand-transition>
    </v-row>
    <!-- Add /Edit Question Dialog -->
    <v-dialog v-model="showAddDialog" max-width="1000px" persistent >
    <v-card>   
        <!-- Form content here -->
        <v-form @submit.prevent="saveQuestion" v-model="isQuestionFormValid" ref="form">      
            <v-toolbar  color="primary" dark> 
                <v-card-title>
                    {{ isEdit ? 'Edit Question' : 'Add New Question' }}
                </v-card-title>
                <v-spacer></v-spacer>
                <v-hover>
                    <template v-slot:default="{ hover }">
                    <v-btn 
                        icon 
                        @click="closeDialog" 
                        :color="hover ? 'red' : 'default'"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    </template>
                </v-hover>
            </v-toolbar>          
            <v-card-text>
            
                <v-row>
                    <v-col cols="6" md="3" sm="3"> 
                        <v-text-field
                            v-model="newQuestion.apq_ques_slno"    
                            label="SL No:"
                            type="number"
                            hint="For Ordinal Position" 
                            :rules="rules.cannotbeNeg"          
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3" sm="3"> 
                        <v-select
                            v-model="newQuestion.apq_ques_type"
                            :items="apq_types"
                            label="Evaluation Type" 
                            :rules="rules.required"                      
                        ></v-select>
                    </v-col>
                    <v-col cols="6" md="3" sm="3"> 
                        <v-text-field
                        v-model="newQuestion.apq_max_score"
                        label="Max Score"
                        type="number"
                        :rules="maxScoreRules"
                        required
                    ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3" sm="3"> 
                        <v-autocomplete
                            v-model="newQuestion.apq_cat_name"
                            :items="categories"        
                            label="Category Type"
                            :loading="isloadingCategories"
                            item-text="category_name"
                            item-value="category_code"
                            prepend-icon="mdi-refresh"
                            @click:prepend="fetchQuesCats" 
                            return-object
                            clearable             
                        >

                        <template slot:no-data>                 
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                <v-btn @click="fetchQuesCats"> Get </v-btn>
                                <span @click="fetchQuesCats" style="color: blue; cursor:pointer;">Fetch from  Server</span>
                                </v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>              
                        </template>    
                    </v-autocomplete>
                    </v-col>
                </v-row>

                <v-textarea
                    v-model="newQuestion.apq_ques_text"
                    label="Question Text"
                    :rules="rules.required"
                    rows="1"
                    required
                ></v-textarea>

                <v-text-field
                    v-model="newQuestion.apq_question_info"
                    label="Additional Info"
                    rows="1"
                ></v-text-field>

                <v-row>
                    <v-col cols="12" md="4" sm="4">
                        <v-select
                            v-model="newQuestion.apq_company"
                            :items="companies"
                            label="Company"
                            @change="get_Dep_Desg"
                            class="text-uppercase"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                        <v-autocomplete
                            :disabled="!newQuestion.apq_company"
                            v-model="newQuestion.apq_dept"
                            :items="departments"
                            :loading="isloadingDepartments"
                            item-text="PDEPTMST_DESC"
                            item-value="PDEPTMST_DOCNO"
                            label='Department'
                            class="text-uppercase"
                            return-object
                            clearable
                            :prepend-icon="newQuestion.apq_company ?'mdi-refresh':''"
                            @click:prepend="fetchDepartments"
                        >
                            <template slot:no-data>                 
                                <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                    No Data Available - 
                                    <span @click="fetchDepartments()" style="color: blue; cursor:pointer;">Fetch from  Server</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>              
                            </template>                
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4" sm="4">
                        <v-autocomplete
                            :disabled="!newQuestion.apq_company"
                            v-model="newQuestion.apq_desg"
                            :items="designations"
                            :loading="isloadingDesignations"
                            item-text="DESIG_DESC"
                            item-value="DESIG_DOCNO"
                            label="Designation"
                            class="text-uppercase"
                            return-object
                            clearable
                            :prepend-icon="newQuestion.apq_company ? 'mdi-refresh':''"
                            @click:prepend="fetchDesignations"
                        >
                            <template slot:no-data>                 
                                <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                    No Data Available - 
                                    <span @click="fetchDesignations()" style="color: blue; cursor:pointer;">Fetch from  Server</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>              
                            </template>                
                        </v-autocomplete>
                    </v-col>
                </v-row> 
                            
                <v-row>
                    <v-col cols="6" md="3" sm="6">
                        <v-switch
                            v-model="newQuestion.is_remark_mandatory"
                            label="Remark Mandatory"
                        ></v-switch>
                    </v-col> 
                    <v-col cols="6" md="3" sm="6">
                        <v-switch
                            v-model="newQuestion.is_active"
                            label="Keep Posted"
                        ></v-switch>
                    </v-col>                     
                    <v-col cols="6" md="3" sm="6">
                        <v-switch
                            v-model="isDefaultOptions"
                            label="Default Options"
                            :disabled="!newQuestion.apq_company"
                        ></v-switch>
                    </v-col>
                    <v-col cols="6" md="3" sm="6">
                        <v-autocomplete
                            v-model="newQuestion.use_default"
                            :items="defaultOptionsLabels"
                            :search-input.sync="defaultOptionSearch"
                            label="Option Set"
                            hint="Select an existing set or enter a new name"
                            persistent-hint
                            outlined
                            small-chips
                            :clearable="true"
                            :loading="isloadingDefaults"
                            @change="updateOptions"
                            :prepend-icon="'mdi-refresh'"
                            @click:prepend="fetchDefaults"
                            :append-icon="showAddIcon ? 'mdi-format-list-group-plus':''"
                            @click:append="addDefaultOptionName"
                        >
                            <template v-slot:no-data>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            "No options found for '<strong>{{ defaultOptionSearch }}</strong>'."
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                        <!-- <v-autocomplete
                            v-model="newQuestion.use_default"
                            :items="defaultOptionsLabels"
                            :search-input.sync="defaultOptionSearch"
                            hide-selected
                            hint="Reuseable option set creation"
                            :label="isDefaultOptions ? 'Default Option Type' : 'New Default Option Name'"
                            persistent-hint
                            outlined
                            small-chips
                            :clearable="!isDefaultOptions"
                            attach
                            @keyup.enter.prevent="addDefaultOptionName"
                            @change="updateOptions"
                            :loading="isloadingDefaults"
                        >
                            <template v-slot:no-data>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title v-if="!isDefaultOptions" >
                                            "<strong>{{ defaultOptionSearch }}</strong>". Press <kbd>enter</kbd> to create a new one.
                                        </v-list-item-title>
                                        <v-list-item-title v-if="!isDefaultOptions" >
                                            "<strong>No default labels</strong>".
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-autocomplete> -->
                        <v-checkbox
                                v-model="isOptionsRequired"
                                label="Preview Defaults"
                                type="checkbox"
                                required
                            ></v-checkbox>
                            
                 
                        <!-- <v-combobox
                            v-model="newQuestion.use_default"
                            :items="defaultOptions"
                            :search-input.sync="defaultOptionSearch"
                            hide-selected
                            hint="Only add if new default set"
                            :label=" isDefaultOptions? 'Default Option Type' :'New Default Option Name'"
                            persistent-hint
                            outlined
                            small-chips
                            :clearable="!isDefaultOptions"
                            attach
                            @keyup.enter="addDefaultOptionName" 
                            >
                            <template v-slot:no-data>
                                <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                    "<strong>{{ defaultOptionSearch }}</strong>". Press <kbd>enter</kbd> to create a new one.
                                    </v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-combobox>  -->                         
                    </v-col>
                </v-row>
                <!-- <div v-if="!isDefaultOptions">                 -->
                <!-- Add Options dynamically -->
                <v-toolbar dense flat>
                    <v-row class="fill-height" align="center" justify="space-around">
                        <v-col cols="12" sm="4">
                            <v-toolbar-title>Options for this Question</v-toolbar-title>
                        </v-col>
                        <v-col cols="12" sm="8" class="d-flex justify-end">
                            <!-- <v-checkbox
                                v-model="isOptionsRequired"
                                label="Preview Defaults"
                                type="checkbox"
                                required
                            ></v-checkbox> -->
                            
                            <div v-if="this.newQuestion.options.length" class="ml-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            class="delete-button"
                                            @click="clearOptions"
                                            :disabled="isDefaultOptions"
                                        >
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Reset All Options</span>
                                </v-tooltip>
                            </div>
                        </v-col>
                    </v-row>
                </v-toolbar>              
                <v-divider></v-divider>
                <div class="mt-11"></div>
                <v-list dense>
                    <v-list-item-group>
                        <v-list-item
                        v-for="(option, index) in newQuestion.options"
                        :key="index"
                        >
                        <v-list-item-content>
                            <v-list-item-subtitle>
                            <v-row>
                                <v-col cols="6" md="3" sm="3">
                                <v-text-field
                                    v-model="option.option_slno"
                                    label="Serial NO:"
                                    type="number"
                                    readonly
                                    hint="Ordinal Position"
                                    :disabled="isDefaultOptions"
                                ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" sm="3">
                                <v-text-field
                                    v-model="option.rating_value"
                                    label="Rating Value"
                                    type="number"
                                    :rules="maxRateRules"
                                    :disabled="isDefaultOptions"
                                ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="6">
                                <v-text-field
                                    v-model="option.option_text"
                                    label="Option Text"
                                    :rules="rules.required"
                                    :disabled="isDefaultOptions"
                                ></v-text-field>
                                </v-col>
                            </v-row>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    outlined
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    @mouseover="hover = true"
                                    @mouseleave="hover = false"
                                    :class="{ 'red--text': hover }"
                                    @click="removeOption(index)"
                                    :disabled="isDefaultOptions"
                                >
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                                </template>
                                <span>Remove</span>
                            </v-tooltip>
                        </v-list-item-action>
                        </v-list-item>                        
                    </v-list-item-group>                    
                </v-list> 
                
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        color="blue darken-1"
                        class="mx-2"
                        fab
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="addOption"
                        :disabled="isDefaultOptions"
                        >
                        <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>New Option</span>
                </v-tooltip>
                <!-- </div> -->            
                <v-overlay :value="isSaving">
                <v-progress-circular
                    indeterminate
                    size="64"
                    primary
                    >
                </v-progress-circular>
                </v-overlay>
        </v-card-text>
        <v-card-actions>       
            <v-row justify="space-around">
                <v-col col="6" md="3"  sm="3">
                    <span class="text--disabled text-uppercase font-italic">
                    <span> {{isEdit ? 'Updated By:':' Created By:' }}</span> {{user.USER_LOGINID}}
                    </span>
                </v-col>
                    <!-- <v-spacer></v-spacer> -->
                <v-col col="6" md="3"  sm="3">
                    <v-switch  v-model="isContinues" label="Continues Mode"></v-switch>
                    <v-switch  v-model="isSaveAsNew" label="Save As New"></v-switch>
                </v-col> 
        
                <!-- <v-spacer></v-spacer> -->
                <v-col col="12" md="6"  sm="6">
                    <v-row justify="space-around">
                    <v-btn color="primary darken-1"   
                        :loading="isSaving"
                        :disabled="isSaving ||!isQuestionFormValid"
                        outlined    
                        type="submit"> 
                        <!-- {{ isEdit ? 'Update ' : 'Save ' }} -->
                        {{ isEdit && !isSaveAsNew ? 'Update ' : isSaveAsNew ? 'Save As New ' : 'Save ' }}
                        <template v-slot:loader>
                            <!-- <span>{{ isEdit ? 'Updating ' : 'Submitting ' }}...</span> -->
                            <span>{{ isEdit && !isSaveAsNew ? 'Updating ' : isSaveAsNew ? 'Saving as New ' : 'Submitting ' }}...</span>
                        </template>
                     </v-btn>
                    <v-btn color="error darken-1"  outlined @click="resetQuestionForm">Reset</v-btn>
                    <v-btn color="warning darken-1"   outlined @click="closeDialog(reset=true)">Cancel</v-btn> 
                    </v-row>
                </v-col>
            </v-row> 
        </v-card-actions>
        </v-form>
    </v-card>
    </v-dialog>

    <!-- Dispaly the questions -->
    <v-data-table
    :headers="headers"
    :items="questions"
    item-key=question_id
    :loading="loading"
    :server-items-length="totalQuestions"
    :items-per-page="itemsPerPage"
    :footer-props="{'items-per-page-options': [10, 20, 30]}"
    @pagination="fetchQuestions"
    >
    
    <template v-slot:item.is_active="{ item }"> 
        <v-icon 
            v-if="item.is_active" 
            color="green">
            mdi-check-circle
        </v-icon>   
        <v-icon 
            v-else
            color="grey">
            mdi-circle-edit-outline
        </v-icon>    
    </template>
    <template v-slot:item.is_remark_mandatory="{ item }"> 
    <v-icon v-if="item.is_remark_mandatory" 
            color="green">
            mdi-check
    </v-icon>     
    </template>
    <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" @click="viewOptionsModal(item)" > //:color = "item?.options.length ? 'primary' : ''"
        mdi-eye 
        </v-icon>
        <v-icon small class="mr-2" @click="editQuestion(item)">
        edit
        </v-icon>
        <v-icon small @click="deleteQuestion(item)">
        delete
        </v-icon>
    </template>
    <template slot:no-data>                  
        No Data Available - 
        <v-button @click="fetchDesignations()" style="color: blue; cursor:pointer;">Fetch from  Server</v-button>                
    </template>
    </v-data-table>
    <!-- View Details Modal -->
    <v-dialog v-model="optionsDialog" max-width="900px">
    <v-card>
        <v-toolbar color="primary" dark >
            <v-card-title>
                Question  Details with Options
            </v-card-title>
            <v-spacer></v-spacer>
            <v-btn   color="error"   @click="closeOptionsDialog">Close</v-btn>
        </v-toolbar>

        <v-card-text>
            <div class="text-h6  font-weight-medium mt-2">
                {{selectedQuestion?.slno || selectedQuestion.apq_ques_id }} .{{selectedQuestion?.apq_ques_text}}
            </div>
            <div class="subheading font-weight-regular grey--text">
                <span>Additional Info: </span>  {{selectedQuestion?.apq_question_info}}  
            </div>
            <div class="my-4 text-subtitle-1">
                <v-row>
                    <v-col col="6">
                        <span>Max Score: </span>  {{selectedQuestion?.apq_max_score}}         
                    </v-col>
                    <v-col col="6">
                        <span>Use Default Option: </span>  {{selectedQuestion?.use_default || 'NA'}}         
                    </v-col>
                </v-row>                    
            </div>
            <v-divider class="my-2"></v-divider>
            <v-list>
            <v-list-item v-for="option in selectedQuestion?.options" :key="option.id">
            <v-list-item-content>
                <v-list-item-title>{{ option.slno }} .{{ option.option_text }}</v-list-item-title>
                <v-list-item-subtitle>RatingValue: {{ option.rating_value }}</v-list-item-subtitle>
            </v-list-item-content>
            </v-list-item>            
        </v-list>
        </v-card-text>
        <!-- <v-card-actions class="justify-center">               
            <v-list-item class="text--disabled " >
                <v-list-item-content>
                    <v-list-item-subtitle class="text-capitalize"> Created By: {{ selectedQuestion?.created_by }}  </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-italic"> ({{ selectedQuestion?.created_at }}) </v-list-item-subtitle>
                </v-list-item-content>
                <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
                <v-list-item-content>
                    <v-list-item-subtitle class="text-capitalize">Last updated by: {{ selectedQuestion?.updated_by }} </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-italic"> ({{ selectedQuestion?.updated_at }}) </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>                
        </v-card-actions> -->
        <v-card-actions class="pa-0">
            <v-container fluid class="pa-0">
            <v-row no-gutters align="center" justify="center">
                <v-col cols="12" sm="6" class="pa-2">
                <v-list-item dense class="text--disabled px-0">
                    <v-list-item-content class="text-center">
                    <v-list-item-subtitle class="text-capitalize text-wrap">
                        Created By: {{ selectedQuestion?.created_by }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-italic text-wrap">
                        ({{ selectedQuestion?.created_at }})
                    </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                </v-col>
                
                <v-divider vertical class="hidden-xs-only"></v-divider>
                
                <v-col cols="12" sm="6" class="pa-2">
                <v-list-item dense class="text--disabled px-0">
                    <v-list-item-content class="text-center">
                    <v-list-item-subtitle class="text-capitalize text-wrap">
                        Last updated by: {{ selectedQuestion?.updated_by }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-italic text-wrap">
                        ({{ selectedQuestion?.updated_at }})
                    </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                </v-col>
            </v-row>
            </v-container>
        </v-card-actions>
    </v-card>
    </v-dialog>  
    </v-container>
</template>

<script>
import dynamic_axios from "../services/dynamic_axios";
// import Axios from "axios";
// import  parse  from 'safe-json-parse';
export default {
    data() {
      return {
        questions: [],
        totalQuestions: 0,
        selectedCompany: null,
        selectedDepartment:'',
        selectedDesignation:'',
        showFilters: false,
        filter_token:'',
        selectedType:'',
        selectedCategory:'',
        selectedQdefaultOption:'',
        optionsDialog:false,
        selectedQuestion:{},
        loading: false,
        currentPage: 1,
        itemsPerPage: 10,       
        departments:[],
        designations:[],
        defaultOptionSearch: null, 
        defaultOptions:[],
        isOptionsRequired:false,
        isDefaultOptions:false,
        isContinues:false,
        isSaveAsNew:false,
        apq_types:['SELF','APPE'],
        company:"",
        headers: [
        { text: 'SlNo:', value: 'apq_ques_slno' },        
        { text: 'Question Text', value: 'apq_ques_text', width: '25%' },
        { text: 'Max Score', value: 'apq_max_score' },
        { text: 'Company', value: 'apq_company' },
        { text: 'Department', value: 'apq_dept' },
        { text: 'Designation', value: 'apq_desg' },
        { text: 'Posted', value: 'is_active' },
        { text: 'Ques Type', value: 'apq_ques_type' },
        { text: 'Opt type', value: 'use_default' },
        { text: 'Category Name', value: 'apq_cat_name' },
        // { text: 'Additional Info', value: 'apq_question_info' }, 
        { text: 'Mandatory Remark', value: 'is_remark_mandatory' },
        { text: 'Actions', value: 'actions', sortable: false }

        ],
        showAddDialog: false,
        hover: false,
        isQuestionFormValid: false,
        categories: [],
        companies:['All','skymat', 'triton'],
        companyOptions: [
            { name: 'skymat', desc: 'SKYMAT' },
            { name: 'triton', desc: 'TRITON' }
        ],
        newQuestion: { 
            apq_cat_id: '',
            apq_cat_name: '',
            apq_ques_id: '',
            apq_ques_slno: '',
            apq_ques_text: '',
            apq_max_score: null,
            apq_ques_type:'',
            apq_company: '',
            apq_dept_id:'',
            apq_dept: null,
            apq_desg_id:'',
            apq_desg: null,
            apq_question_info: '',
            is_remark_mandatory: false,
            is_active: true,
            use_default:null,
            options:[],
        },
        rules: {
            required: [value => !!value || 'Required.'], 
            cannotbeNeg:  [value => value >= 0 || 'Score cannot not be -ve']     
        },
        maxScoreRules: [
            v => !!v || 'This field is required', // Checks if the field is not empty
            v => v >= this.maxOptionRating || `Max score cannot be less than the highest option rating (${this.maxOptionRating}).`,
            v => v >= 0 || 'Score cannot not be -ve'
        ],
        maxRateRules:[
            v => v !== null && v !== undefined && v !== '' || 'This field is required', 
            v => v <= this.newQuestion.apq_max_score || 'Rate cannot exceed Max score',
            v => v >= 0 || 'Rate cannot not be -ve'
        ],   
        isloadingDepartments : false,
        isloadingDesignations : false,
        isloadingDefaults : false,
        isloadingCategories : false,        
        isSaving : false,
        isEdit: false,
      };
    },
    computed: {
        user() {     
            return this.$store.getters.factsuser;      
        },
        userProfile(){
            return this.$store.getters.userProfile;
        },
        perferedAPI() {
            return this.$store.getters.perferedAPI;
        }, 
        fbuserdata() {
            return this.$store.getters.fbuserdata;
        },
        maxOptionRating() {
            if (this.newQuestion.options.length > 0) {
                return this.newQuestion.options.reduce((max, option) => {
                    return Math.max(max, Number(option.rating_value));
                }, 0);
            }
            return 0; // Default to 0 if there are no options
        },
        defaultOptionsLabels() {
            if (Array.isArray(this.defaultOptions)) {
                // If the defaultOptions is an array (when isOptionsRequired is false)
                return this.defaultOptions;
            } else {
                // If the defaultOptions is an object (when isOptionsRequired is true)
                return Object.keys(this.defaultOptions);
            }
        },
        showAddIcon() {
        // Check if the current search text is not in the defaultOptionsLabels
            return this.defaultOptionSearch && !this.defaultOptionsLabels.includes(this.defaultOptionSearch.trim());
        }
    },
    watch: {
        fbuserdata(newValue) {
            this.selectedCompany.name = newValue.company; // Set default company based on user data
            this.get_Dep_Desg(); // Fetch departments when company is set
        },
        // isDefaultOptions(newValue){
        //     if(newValue){                
        //         // if(!this.isEdit) 
        //         this.fetchDefaults();
        //         // this.newQuestion.use_default = 'DEFAULT'
        //     } 
        //     else
        //         this.newQuestion.use_default =''
        // },
        isDefaultOptions(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue) {
                    this.fetchDefaults();
                } else {
                    this.newQuestion.use_default = '';
                }
            }
        },
        departments(newDepartments) {
            if (newDepartments.length > 0 && this.editing && this.newQuestion.apq_dept_id) {
                this.newQuestion.apq_dept = newDepartments.find(dept => dept.PDEPTMST_DOCNO === this.newQuestion.apq_dept_id) || {};
            }
        },
        // Similar setup for designations
        designations(newDesignations) {
            if (newDesignations.length > 0 && this.editing && this.newQuestion.apq_desg_id) {
                this.newQuestion.apq_desg = newDesignations.find(desg => desg.DESIG_DOCNO === this.newQuestion.apq_desg_id) || {};
            }
        },
        newQuestion: {
            handler() {
                // This will force re-validation on any change to the newQuestion object
                if (this.$refs.form) {
                    this.$refs.form.validate();
                }
            },
            deep: true
        },  
    },
    mounted() {
      this.initializeSelectedCompany();
      this.fetchQuestions({ page: this.currentPage, itemsPerPage: this.itemsPerPage  });
    },
    methods: {
        initializeSelectedCompany() {
            if (this.fbuserdata?.company) {
                const companyName = this.fbuserdata.company.toLowerCase();
                // Find the matching company option
                const matchedCompany = this.companyOptions.find(option => option.name === companyName);
                if (matchedCompany) {
                    this.selectedCompany = matchedCompany;
                } else {
                    console.warn('No matching company found for:', companyName);
                }
            }
        },
        viewOptionsModal(question){
          this.selectedQuestion = question;
          this.optionsDialog = true;
        },
        closeOptionsDialog(){
            this.selectedQuestion = {}
            this.optionsDialog = false;
        },
        addOption() {
            const nextSlno = this.newQuestion.options.length + 1;
            this.newQuestion.options.push({ option_text: '', rating_value: '' ,option_slno:nextSlno });
        },
        removeOption(index) {
            this.newQuestion.options.splice(index, 1);
            this.newQuestion.options.forEach((option, idx) => {
                option.slno = idx + 1;
            });
        },
        clearOptions(){
            this.newQuestion.options = [];
        },
        get_Dep_Desg(){
            this.fetchDepartments();
            this.fetchDesignations();
        },
        async ensureCategoriesLoaded() {
            if (!this.categories.length) {
                await this.fetchQuesCats();
            }
        },
        async ensureDepartmentsLoaded() {
            if (!this.departments.length) {  // Checks if the department list is empty
                await this.fetchDepartments();  // Calls the method to fetch departments
            }
        },
        async ensureDesignationsLoaded() {
            if (!this.designations.length) {  // Checks if the designations list is empty
                await this.fetchDesignations();  // Calls the method to fetch designations
            }
        },
        async fetchFilterOptions(refresh = true) {
            if (!this.selectedCompany?.name) {
                this.departments = [];
                this.designations = [];
                return;
            }

            let company = this.selectedCompany.name.toLowerCase();

            // Check if force refresh is required
            if (refresh) {
                // Clear cached data if refresh is requested
                localStorage.removeItem(`${company}-departments`);
                localStorage.removeItem(`${company}-designations`);
                this.selectedDepartment ='';
                this.selectedDesignation='';
                this.selectedCategory='';
                this.selectedType='';
            }

            // Fetch departments and designations with respect to the refresh flag
            this.fetchDepartments(refresh);
            this.fetchDesignations(refresh);
            this.fetchQuesCats();
        },
        // updateOptions(selectedType) {
        //     if (this.defaultOptions[selectedType]) {
        //         this.newQuestion.options = this.defaultOptions[selectedType].options;
        //     }
        // },
        updateOptions(selectedOption) {
            console.log('Selected Option:', selectedOption);  // Debug: See what's being passed

            // Ensure defaultOptions is structured to use selectedOption as a key
            if (selectedOption && this.defaultOptions[selectedOption]) {
                this.newQuestion.options = this.defaultOptions[selectedOption].options;
            } else {
                this.newQuestion.options = [];
            }
        },
        addDefaultOptionName() {
            if (this.isDefaultOptions) return; // Prevent adding if 'isDefaultOptions' is true
            if (!this.defaultOptionSearch.trim()) return;
            const newDefaultOptionName = this.defaultOptionSearch ? this.defaultOptionSearch.trim() : '';
            if (newDefaultOptionName && !this.defaultOptionsLabels.includes(newDefaultOptionName)) {
                this.defaultOptions[newDefaultOptionName] = { use_default: newDefaultOptionName, options: [] };
                this.defaultOptionsLabels.push(newDefaultOptionName); // Update the labels
                this.newQuestion.use_default = newDefaultOptionName;  // Set the newly added option as selected
            }
        },
        // addDefaultOptionName() {
        //     if (this.isDefaultOptions) return // only add if new default
        //     const newDefaultOptionName = this.defaultOptionSearch ? this.defaultOptionSearch.trim() : '';  // Use an empty string as a fallback
        //     if (newDefaultOptionName && !this.defaultOptions.includes(newDefaultOptionName)) {
        //         this.defaultOptions.push(newDefaultOptionName);
        //     }
        //     if (newDefaultOptionName && !this.banner.tags.includes(newDefaultOptionName)) {
        //         if (this.banner.tags.length < 1) {
        //         this.banner.tags.push(newDefaultOptionName);
        //         } else {
        //         this.$toast.warn('You can only add up to 1 tags per default.'); // Replace with a more appropriate notification
        //         }
        //     }
        //     this.defaultOptionSearch = '';  // Reset to empty string after adding
        // },
        async fetchQuesCats() {
            this.isloadingCategories = true;
            // console.log(this.selectedCompany);
            try {
                let company = this.newQuestion.apq_company === 'All' ? this.selectedCompany.name : this.newQuestion.apq_company;

                // Fallback to selectedCompany if company is null or undefined
                if (!company) {
                    company = this.selectedCompany ? this.selectedCompany.name.toLowerCase() : null;
                }

                  // Make sure that a valid company is always used
                if (!company) {
                    this.$toast.warning('No valid company selected')
                    // throw new Error("No valid company selected");  // You can handle this more gracefully as needed
                }
                const response = await dynamic_axios.get(`appraisal/appQuesCat`, {
                // const response = await Axios.get(`http://127.0.0.1:9230/appraisal/appQuesCat`, {
                    // params,
                    apiName: company
                    
                });
                this.categories = response.data.categories;
                this.updateFormDataWithCategories();
            } catch (error) {
                console.error('Error fetching categories:', error);
                this.categories = [];  // Reset to empty array in case of error
            } finally {
                this.isloadingCategories = false;
            }
        },
        updateFormDataWithCategories() {
            if (this.categories.length > 0 && this.newQuestion.apq_cat_id) {
                const foundCategory = this.categories.find(cat => cat.category_code.toString() === this.newQuestion.apq_cat_id.toString());
                if (foundCategory) {
                    this.newQuestion.apq_cat_name = foundCategory;
                }
            }
        },
        async fetchDefaults() {
            if (!this.isDefaultOptions) return;
            // if (this.newQuestion.apq_company) {
                this.isloadingDefaults= true;
                try {
                    let company = this.newQuestion.apq_company === 'All' ? this.selectedCompany.name : this.newQuestion.apq_company;
                    // console.log("this.newQuestion.apq_company",this.newQuestion.apq_company)
                    // console.log("this.selectedCompany.name",this.selectedCompany.name)
                    // console.log("company",company)
                    const params = {
                        isOptionsRequired: this.isOptionsRequired // Use the state of the checkbox
                    };
                    const response = await dynamic_axios.get(`appraisal/appDefaultoptions`,   {
                    // const response = await Axios.get(`http://127.0.0.1:9230/appraisal/appDefaultoptions`, {
                        params,
                        apiName: company  // Specify which API configuration to use
                    });
                    
                    this.defaultOptions = response.data.default_options;  
                } catch (error) {
                    console.error('Error fetching departments:', error);
                    this.defaultOptions = ['DEFAULT'];  
                } finally {
                    this.isloadingDefaults = false;
                }
            // } else {
            //     this.defaultOptions = ['DEFAULT'];  
            // }
        },
        async fetchDepartments(refresh = false) {
            let company = this.newQuestion.apq_company === 'All' ? (this.selectedCompany ? this.selectedCompany.name.toLowerCase() : null) : this.newQuestion.apq_company;
            console.log("this.newQuestion.apq_company",this.newQuestion.apq_company)
            console.log("this.selectedCompany.name",this.selectedCompany.name)
            console.log("company",company)
           // Fallback to selectedCompany if company is null or undefined
            if (!company) {
                company = this.selectedCompany ? this.selectedCompany.name.toLowerCase() : null;
            }
            if (company) {
            // if (this.newQuestion?.apq_company || typeof this.selectedCompany !== 'undefined') {
                // let company = this.selectedCompany.name.toLowerCase();
                const storageKey = `${company}-departments`;

                this.isloadingDepartments = true;
                try {

                    if (!refresh) {
                        const cachedData = localStorage.getItem(storageKey);
                        // console.log("cachedDataDep",cachedData);
                        if (cachedData) {
                            // this.departments = JSON.parse(cachedData);
                            
                            try {
                                this.designations = JSON.parse(cachedData);
                            } catch (error) {
                                console.error('Error parsing cached data:', error);
                                // Handle the error here, e.g., remove the corrupted data from localStorage
                                localStorage.removeItem(storageKey);
                            }
                            return;
                        }
                    }
                    // let company = this.newQuestion.apq_company
                    const response = await dynamic_axios.get(`pay_depart`, {
                    // const response = await Axios.get(`http://127.0.0.1:9230/pay_depart`, {
                        apiName: company  // Specify which API configuration to use
                    });
                    
                    this.departments = response.data.pay_departs;  // Directly use the API response
                    localStorage.setItem(storageKey, JSON.stringify(this.departments));
                } catch (error) {
                    console.error('Error fetching departments:', error);
                    this.departments = [];  // Reset the departments array on error
                } finally {
                    this.isloadingDepartments = false;
                }
            } else {
                this.departments = [];  // Clear departments if no company is selected
            }
        },
        async fetchDesignations(refresh = false) {
            // Decide which company to use
            let company = this.newQuestion.apq_company === 'All' ? (this.selectedCompany ? this.selectedCompany.name.toLowerCase() : null) : this.newQuestion.apq_company;
            // if (this.newQuestion?.apq_company || typeof this.selectedCompany !== 'undefined') {
                // console.log("this.newQuestion.apq_company",this.newQuestion.apq_company)
                // console.log("this.selectedCompany.name",this.selectedCompany.name)
                // console.log("company",company)
            // Fallback to selectedCompany if company is null or undefined
            if (!company) {
                company = this.selectedCompany ? this.selectedCompany.name.toLowerCase() : null;
            }
            if(company){
                // let company = this.selectedCompany.name.toLowerCase();
                const storageKey = `${company}-designations`;

                this.isloadingDesignations = true;
                // console.log("this.newQuestion.apq_company", this.newQuestion.apq_company)
                try {
                    if (!refresh) {
                        const cachedData = localStorage.getItem(storageKey);
                        // console.log("cachedDataDesg",cachedData);
                        if (cachedData) {
                            // this.designations = JSON.parse(cachedData);

                            try {
                                this.designations = JSON.parse(cachedData);
                            } catch (error) {
                                console.error('Error parsing cached data:', error);
                                // Handle the error here, e.g., remove the corrupted data from localStorage
                                localStorage.removeItem(storageKey);
                            }

                            return;
                        }
                    }
                    // let company = this.newQuestion.apq_company
                    const response = await dynamic_axios.get(`pay_design`, {
                    // const response = await Axios.get(`http://127.0.0.1:9230/pay_design`, {
                        apiName: company  // Specify which API configuration to use
                    });
                    // console.log(response);
                    this.designations = response.data.pay_designs;  // Directly use the API response
                    localStorage.setItem(storageKey, JSON.stringify(this.designations));
                } catch (error) {
                    console.error('Error fetching designations:', error);
                    this.designations = [];  // Reset the departments array on error
                } finally {
                    this.isloadingDesignations = false;
                }
            } else {
                this.designations = [];  // Clear departments if no company is selected
            }
        },
        async fetchQuestions(pagination) {
            if (!this.selectedCompany) return;
            const companyName= this.selectedCompany.name;
            this.loading = true;
            const { page, itemsPerPage } = pagination || { page: this.currentPage, itemsPerPage: this.itemsPerPage };
            
             // Gather user-related data.
            // const employ_id = this.user.USER_EMP_DOCNO;
            // const EMPMST_DESG_DOCNO = this.userProfile.EMPMST_DESG_DOCNO;
            // const dep = this.userProfile.EMPMST_UD_TXT5;
            const user_id = this.user.USER_LOGINID;
            const apq_company  = companyName;
            // const apq_dept = this.selectedDepartment?.PDEPTMST_DOCNO;
            // const apq_desg = this.selectedDesignation?.DESIG_DOCNO;
            const apq_dept_id = this.selectedDepartment?.PDEPTMST_DOCNO;
            const apq_desg_id = this.selectedDesignation?.DESIG_DOCNO;
            const apq_type = this.selectedType;
            const apq_cat_id = this.selectedCategory.category_code
            const filter_token = this.filter_token;
            console.log("apq_cat_id",apq_cat_id)
            // Constructing the query string
            const params = {
                // employ_id,
                // EMPMST_DESG_DOCNO,
                // dep,
                user_id,
                apq_company,
                // apq_dept,
                // apq_desg,
                apq_dept_id,
                apq_desg_id,
                apq_cat_id,
                apq_type,
                filter_token,
                page,
                per_page: itemsPerPage
            };

            try {              
            const response = await dynamic_axios.get('appraisal/appraisalQuestionaire', {
            // const response = await Axios.get('http://127.0.0.1:9230/appraisal/appraisalQuestionaire', {
                params,
                apiName: companyName  // Replace `this.company` with your actual data source or variable
            });
            // console.log("response.data.",response.data)
            this.questions = response.data.questions;
            // console.log("questions",this.questions)
            this.totalQuestions = response.data.total || this.totalQuestions;
            this.pages = response.data.pages || this.pages;
            this.currentPage = response.data.current_page;
            this.itemsPerPage = itemsPerPage;
            this.filter_token=response.data.filter_token;
            } catch (error) {
                console.error('Error fetching questions:', error);
                this.$toast.error(`Error fetching questions ${companyName}`)
            } finally {
                this.loading = false;
            }
        },
        editQuestion(question) {
                       
            this.newQuestion = {
                ...this.newQuestion, // Use existing defaults
                ...question, // Apply fetched question properties
                apq_cat_name: this.categories.find(cat => cat.category_code.toString() === question.apq_cat_id.toString()) || { category_code: '', category_name: '' },
                apq_dept: question.apq_dept_id ? this.departments.find(dept => dept.PDEPTMST_DOCNO === question.apq_dept_id.toString()) || { PDEPTMST_DOCNO: '', PDEPTMST_DESC: '' } : { PDEPTMST_DOCNO: '', PDEPTMST_DESC: '' },
                apq_desg: question.apq_desg_id ? this.designations.find(desg => desg.DESIG_DOCNO === question.apq_desg_id.toString()) || { DESIG_DOCNO: '', DESIG_DESC: '' }: { DESIG_DOCNO: '', DESIG_DESC: '' },
                options: question.options || []
            };

            this.isDefaultOptions = !!question.use_default;
            this.newQuestion.use_default = question.use_default || '';

            Promise.all([
                this.ensureCategoriesLoaded(),
                this.ensureDepartmentsLoaded(),
                this.ensureDesignationsLoaded()
            ]).then(() => {

            });
            // console.log("this.newQuestion",this.newQuestion);
            // this.newQuestion = {
            //     ...this.newQuestion, // This spreads existing default values into newQuestion, ensuring any structure not explicitly set by the fetched question is initialized properly.
            //     ...question, // This spreads the fetched question's properties over the new defaults, updating it with actual data.
                
            //     apq_cat_name: question.apq_cat_id ? {
            //         category_code: question.apq_cat_id.toString(),
            //         category_name: question.apq_cat_name || ''
            //     } : { category_code: '', category_name: '' },
                
            //     apq_dept: question.apq_dept_id ? {
            //         PDEPTMST_DOCNO: question.apq_dept_id.toString(), // Convert ID to string if not null
            //         PDEPTMST_DESC: question.apq_dept || '' // Use description if available
            //     } : { PDEPTMST_DOCNO: '', PDEPTMST_DESC: '' }, // Provide empty defaults if `apq_dept_id` is null

            //     apq_desg: question.apq_desg_id ? {
            //         DESIG_DOCNO: question.apq_desg_id.toString(), // Convert ID to string if not null
            //         DESIG_DESC: question.apq_desg || '' // Use description if available
            //     } : { DESIG_DOCNO: '', DESIG_DESC: '' }, // Provide empty defaults if `apq_desg_id` is null

            //     options: question.options ? question.options.map(option => ({ ...option })) : []
            // };

            // this.isDefaultOptions = !!question.use_default;
            // this.newQuestion.use_default = question?.use_default ?? ''
            // const options= question.options?.map(option => ({ ...option })) || []
            // const use_default = question?.use_default
            // console.log("use_default",use_default)

            // // Ensure that departments and designations are loaded before setting them
            // this.fetchDepartments().then(() => {
            //     this.newQuestion.apq_dept = this.departments.find(dept => dept.PDEPTMST_DOCNO === question.apq_dept_id) || {
            //         PDEPTMST_DOCNO: question.apq_dept_id,
            //         PDEPTMST_DESC: question.apq_dept
            //     };
            // });

            // this.fetchDesignations().then(() => {
            //     this.newQuestion.apq_desg = this.designations.find(desg => desg.DESIG_DOCNO === question.apq_desg_id) || {
            //         DESIG_DOCNO: question.apq_desg_id,
            //         DESIG_DESC: question.apq_desg
            //     };
            // });
            
            // this.newQuestion = { 
            //     ...question,
            //     // apq_dept: {
            //     //     PDEPTMST_DOCNO: question.apq_dept_id, // Assuming apq_dept_id is the identifier
            //     //     PDEPTMST_DESC: question.apq_dept // Assuming apq_dept is the description
            //     // },

            // };
            // this.newQuestion[options] = use_default ? options : [];
            // // this.newQuestion.apq_dept = this.departments.find(dept => dept.PDEPTMST_DOCNO === this.newQuestion.apq_dept_id);
            // // this.newQuestion.apq_desg = this.designations.find(desg => desg.DESIG_DOCNO === this.newQuestion.apq_desg_id);
            // this.newQuestion.apq_dept= {
            //         PDEPTMST_DESC: question.apq_dept, // Assuming apq_dept is the description
            //         PDEPTMST_DOCNO: question.apq_dept_id.toString() // Assuming apq_dept_id is the identifier
                    
            //     },
            // this.newQuestion.apq_desg= {
            //         DESIG_DESC: question.apq_desg, // Assuming apq_desg is the description
            //         DESIG_DOCNO: question.apq_desg_id.toString(), // Assuming apq_desg_id is the identifier
                   

            //     },
            // this.isDefaultOptions =  use_default ? true : false;

            // { "DESIG_DOCNO": 101, "DESIG_DESC": "Accountant" } 
            // { "DESIG_DESC": "Accountant", "DESIG_DOCNO": "101", "DESIG_DOCTYPE": "DES" } 
            
            // console.log('Edit:', question);
            this.showAddDialog = true; // Open the dialog in edit mode
            this.isEdit = true; // Set an edit flag to true
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                    // Optionally validate immediately if needed
                    // this.$refs.form.validate();
                }
            });
            // console.log(this.newQuestion)
            
            
        },
        resetQuestionForm(){           
             // Reset the form fields and validation state using Vuetify's form reference
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.newQuestion= {
                apq_cat_id: '',
                apq_cat_name: '',
                apq_ques_id: '',
                apq_ques_slno: '',
                apq_ques_text: '',
                apq_max_score: null,
                apq_ques_type:'',
                apq_company: '',
                apq_dept_id:'',
                apq_dept: null,
                apq_desg_id:'',
                apq_desg: null,
                apq_question_info: '',
                is_remark_mandatory: false,
                is_active: true,
                use_default:null,
                options:[],
            };
            this.isEdit=false
        },
        closeDialog(reset='false'){ 
            if (!this.isContinues || reset === true) {
                if (reset && this.isEdit){                
                    this.resetQuestionForm();               
                }            
                this.showAddDialog = false;
                this.isEdit = false;
                // console.log("this.newQuestion", JSON.stringify(this.newQuestion));
            }
        },
        async saveQuestion() {
            if (!this.isQuestionFormValid) return  ; 
            // const isValid = this.$refs.form.validate();
            // if (isValid) {
                if (this.isEdit && !this.isSaveAsNew) {
                    await this.updateQuestion();  // Call update method if editing                   
                } else {
                    await this.addQuestion();     // Call add method if creating new
                }
                if(!this.isContinues){
                    this.closeDialog();
                }  // Close the dialog after the operation
            // } else {
            //     this.$toast.error("Please correct the errors in the form.");
            // }
        },
        async addQuestion() { 
            if (!this.newQuestion.use_default && !this.newQuestion.options.length) {
                this.$toast.warning('Please add at least one option for the new default set.');
                return;
            }
            this.isSaving = true
            let apiNames = this.newQuestion.apq_company === 'All' ? ['skymat', 'triton'] : [this.selectedCompany.name];
            console.log("apiNames",apiNames)
            const promises = apiNames.map(async apiName => {
                console.log("apiName",apiName)
            try {
                const payload ={
                    ...this.newQuestion,
                    apq_cat_id : this.newQuestion.apq_cat_name ? this.newQuestion.apq_cat_name.category_code : null,
                    apq_cat_name : this.newQuestion.apq_cat_name ? this.newQuestion.apq_cat_name.category_name : null,
                    apq_dept_id: this.newQuestion.apq_dept ? this.newQuestion.apq_dept.PDEPTMST_DOCNO : null,
                    apq_dept: this.newQuestion.apq_dept ? this.newQuestion.apq_dept.PDEPTMST_DESC : null,
                    apq_desg_id: this.newQuestion.apq_desg ? this.newQuestion.apq_desg.DESIG_DOCNO : null,
                    apq_desg: this.newQuestion.apq_desg ? this.newQuestion.apq_desg.DESIG_DESC : null,
                    user_id:this.user.USER_LOGINID,
                }
                if (this.isSaveAsNew) {
                    delete payload.apq_ques_id;
                }
                
                // const response = await Axios.post('http://127.0.0.1:9230/appraisal/appraisalQuestionaire', payload, {
                const response = await dynamic_axios.post('/appraisal/appraisalQuestionaire', payload, {
                    apiName: apiName
                });
                console.log("response", response)
                this.$toast.success(`${apiName} ${response.message}`, response);
                // console.log("response" ,response)
                // Assuming response.data contains the newly added question
                // Accessing the question from response.data
                if (response.data && response.data.question) {
                    this.questions.push(response.data.question);  // Update UI with the new question
                    if(!this.isContinues){
                        this.resetQuestionForm();
                    }
                } else {
                    throw new Error('Invalid response structure from API');
                }
                return { success: true, apiName: apiName };
                } catch (error) {
                this.$toast.error(`Error adding question for ${apiName}: ${error.message}`);
                return { success: false, apiName: apiName };
                }
            });

            await Promise.all(promises).finally(() => {
                this.closeDialog();
                this.isSaving = false;
            });
         
        },
        async updateQuestion() {
            this.isSaving = true;
            try {
                let company = this.newQuestion.apq_company === 'All' ? (this.selectedCompany ? this.selectedCompany.name.toLowerCase() : null) : this.newQuestion.apq_company;
                const payload ={
                    ...this.newQuestion,
                    apq_cat_id : this.newQuestion.apq_cat_name ? this.newQuestion.apq_cat_name.category_code : null,
                    apq_cat_name : this.newQuestion.apq_cat_name ? this.newQuestion.apq_cat_name.category_name : null,
                    apq_dept_id: this.newQuestion.apq_dept ? this.newQuestion.apq_dept.PDEPTMST_DOCNO : null,
                    apq_dept: this.newQuestion.apq_dept ? this.newQuestion.apq_dept.PDEPTMST_DESC : null,
                    apq_desg_id: this.newQuestion.apq_desg ? this.newQuestion.apq_desg.DESIG_DOCNO : null,
                    apq_desg: this.newQuestion.apq_desg ? this.newQuestion.apq_desg.DESIG_DESC : null,
                    user_id:this.user.USER_LOGINID,
                }
                               
                // console.log(`Updating question with ID: ${this.newQuestion.apq_ques_id}`);
                // const response = await Axios.put(`http://127.0.0.1:9230/appraisal/appraisalQuestionaire/${this.newQuestion.apq_ques_id}`, payload, {
                const response = await dynamic_axios.put(`/appraisal/appraisalQuestionaire/${this.newQuestion.apq_ques_id}`, payload, {
                    apiName:company //this.newQuestion.apq_company  // Assuming the company name is used to determine the API config
                });
                this.$toast.success(`${this.newQuestion.apq_company} question updated successfully.`);
                // console.log("Update response", response.data);
                // this.fetchQuestions();  // Refresh the list of questions
                // Find the index of the question and replace it with the updated one
                const index = this.questions.findIndex(q => q.apq_ques_id === this.newQuestion.apq_ques_id);
                if (index !== -1) {
                    this.questions.splice(index, 1, response.data.question);
                }
                if(!this.isContinues){
                    this.resetQuestionForm();
                }

            } catch (error) {
                console.error('Update error:', error);
                this.$toast.error(`Failed to update question for ${this.newQuestion.apq_company.name}: ${error.message}`);
            } finally {
                this.isSaving = false;
            }
        },
        async toggleQuestionStatus(questionId, isActive) {
            const token = this.userToken;  // Assuming you store the token somewhere in your Vue app
            try {
                // const response = await Axios.patch(`http://127.0.0.1:9230/appraisal/appraisalQuestionaire/${questionId}/status`, {
                const response = await dynamic_axios.patch(`/appraisal/appraisalQuestionaire/${questionId}/status`, {
                    isActive: isActive
                }, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                console.log("Status updated:", response.data);
                this.$toast.success("Question status updated successfully");
                // Optionally refresh or update the local state to reflect the change
            } catch (error) {
                console.error("Failed to update question status:", error);
                this.$toast.error("Failed to update question status");
            }
        },
        async deleteQuestion(question) {
        // Confirmation dialog using SweetAlert2
            try {
                const result = await this.$swal({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this question!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                });

                if (result.isConfirmed) {
                    // Gather user-related data.
                    const user_id= this.user.USER_LOGINID;
                    const company = question.apq_company;
                    const apq_id = question.apq_ques_id;
                    console.log("question",question)

                    const response = await dynamic_axios.delete(`appraisal/appraisalQuestionaire/${apq_id.toString().trim()}`, {
                        params: { // Correctly pass parameters as part of the config object
                            user_id,
                            company,
                            apq_id
                        },
                        headers: { // Optional: Additional headers if necessary
                            'Content-Type': 'application/json'
                        },
                        apiName: company // Pass `company` for dynamic axios configuration
                    });

                    // // Constructing the query string
                    // const params = {
                    //     user_id,
                    //     company,
                    //     apq_id
                    // };

                    // // Handle delete
                    // // console.log('Delete:', question);

                    // // Uncomment the appropriate line for production or development environment
                    // const response = await dynamic_axios.delete(`appraisal/appraisalQuestionaire/${apq_id.toString().trim()}`,params, {
                    // // const response = await Axios.delete(`http://127.0.0.1:9230/appraisal/appraisalQuestionaire/${apq_id.toString().trim()}`, {
                    //     apiName: this.newQuestion.apq_company  // Replace `this.company` with your actual data source or variable
                    // });
                    // Check if the deletion was successful
                    if (response.status === 204) {
                        this.$toast.success("Deleted successfully");
                        // Update the UI by filtering out the deleted question
                        this.questions = this.questions.filter(q => q.apq_ques_id !== question.apq_ques_id);
                    } else {
                        // Handling different types of error messages from the server
                        this.$toast.error("Failed to delete the question");
                    }
                }
            } catch (error) {
                console.error('Deletion error:', error);
                // Handle case where error response has a specific message
                if (error.response && error.response.data.message) {
                    this.$toast.error(error.response.data.message);
                } else {
                    this.$toast.error("An error occurred during deletion.");
                }
            }
        },
    }
}
</script>
<style scoped>
.delete-button:hover .v-icon {
  color: red; /* Change icon color on hover */
}
</style>